import React from 'react'
import Table from '../common/Table.js'
import ModalBasic from '../../pages/component/ModalBasic.js'
import TextInput from '../common/TextInput.js'
import ToggleSwitch from '../common/ToggleSwitch.js'
import MultiSelectDropdown from '../dropdown/MultiSelectDropdown.js'

function QCMonogramCommon(props) {
    return (
        <div>
            <button
                className='add-btn w-fit h-fit mb-4'
                onClick={props.openTestDetailsModal}
            >
                Add
            </button>
            <Table
                tableData={props.tableData}
                columns={props.columns}
                scrollHeight="calc(100dvh - 190px)"
            />

            <ModalBasic
                id="qcMonogram"
                modalOpen={props.openModel}
                setModalOpen={props.toggleModal}
                title="Add Test Details"
                className="!w-[60%] p-5"
            >
                <div className='field-grp grid grid-cols-1 gap-2.5'>
                    <div className='input-grp'>
                        <label>Test Name</label>
                        <MultiSelectDropdown
                            drpIdentity="testId"
                            className={`${props.validState?.error?.testId ? "errorInput" : ""}`}
                            options={props.testMasterList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                props.setFilterParametersForItemName(selected, "testId")
                            }
                            allowSelectAll={false}
                            value={props.testDetails.testId && props.testMasterList.filter(
                                (party) =>
                                    party.value === props.testDetails.testId
                            )}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Result</label>
                        <textarea
                            rows={1}
                            value={props.testDetails.result}
                            onChange={(e) => props.handleChange(e, 'result')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Limit</label>
                        <textarea
                            rows={1}
                            value={props.testDetails.limit}
                            onChange={(e) => props.handleChange(e, 'limit')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Complete Test in Own Laboratory</label>
                        <ToggleSwitch
                            checked={props.testDetails.isOwnLaboratory === 1}
                            onChange={props.handleToggle}
                        />
                    </div>
                </div>
                <div className='btn-grp flex items-center justify-end gap-5 mt-2.5 pt-2.5 border-t border-gray-200'>
                    {props.testDetails.monoGramId ? (
                        <button
                            onClick={props.updateQCMonogram}
                            className='search-btn'>
                            Save
                        </button>
                    ) : (
                        <button
                            onClick={props.submitQCMonogram}
                            className='search-btn'>
                            Add
                        </button>
                    )}
                    <button className='cancel-btn'
                        onClick={props.toggleModal}
                    >
                        Cancel
                    </button>
                </div>
            </ModalBasic>
        </div>
    )
}

export default QCMonogramCommon